import { useEffect } from 'react';
import type { DashboardsApiClass } from '@app/types/sdk';

export interface GrafanaEmbedSessionKeepaliveOptions {
  dashboardsApi: DashboardsApiClass;
  orgId: string | null;
  enabled: boolean;
  intervalSeconds?: number;
  logTag?: string;
}

const DEFAULT_INTERVAL_SECONDS = 240;

export const useGrafanaEmbedSessionKeepalive = ({
  dashboardsApi,
  orgId,
  enabled,
  intervalSeconds = DEFAULT_INTERVAL_SECONDS,
  logTag = 'grafana-embed'
}: GrafanaEmbedSessionKeepaliveOptions) => {
  useEffect(() => {
    if (!enabled || !orgId) {
      return;
    }

    const refresh = () =>
      dashboardsApi
        .orgsOrgIdGrafanaEmbedSessionPost({ orgId }, { credentials: 'include' })
        .catch((error: unknown) => console.warn(`[${logTag}] failed to refresh grafana embed session`, error));

    // Refresh immediately on enable, then keep it alive periodically. This avoids iframe refresh failures
    // when the short-lived HttpOnly cookie expires (~5 min in current deployments).
    refresh();

    const id = window.setInterval(refresh, intervalSeconds * 1000);
    return () => window.clearInterval(id);
  }, [dashboardsApi, enabled, intervalSeconds, logTag, orgId]);
};
